/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesListAliases {
  ADD_CLINICAL_NOTES_CUSTOM_DYNAMIC_BUTTON = 'add-clinical-notes-custom-dynamic-button',
  AUTOC_CLINICAL_NOTES_PRESENTATION = 'autoc-clinical-notes-presentation',
  AUTOC_CLINICAL_NOTES_TYPE = 'autoc-clinical-notes-type',
  CLINICAL_NOTE_CARD = 'clinical-note-card',
  CONTEXTUAL_BAR = 'contextual-bar',
  DATE_PICKER_DATE_END = 'date-picker-date-end',
  DATE_PICKER_DATE_INIT = 'date-picker-date-init',
  DECK_CLINICAL_NOTES = 'deck-clinical-notes',
  FETCH_CLINICAL_NOTES_LIST = 'fetch-clinical-notes-list',
  FETCH_CLINICAL_NOTES_TYPE = 'fetch-clinical-notes-type',
  FIELD_CLINICAL_NOTES_TYPE = 'field-clinical-notes-type',
  FIELD_TYPE_PRESENTATION = 'field-type-presentation',
  FILTER_CLINICAL_NOTES = 'filter-clinical-notes',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTERED_LIST_CLINICAL_NOTES = 'filtered-list-clinical-notes',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_CLINICAL_NOTES_LIST = 'layout-clinical-notes-list',
  LEGENDS_CLINICAL_NOTES = 'legends-clinical-notes',
  MAPPER_CLINICAL_NOTES_PRESENTATION = 'mapper-clinical-notes-presentation',
  MAPPER_CLINICAL_NOTES_TYPE = 'mapper-clinical-notes-type',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  TEXT_CLINICAL_NOTES_PRESENTATION = 'text-clinical-notes-presentation',
  TEXT_CLINICAL_NOTES_TYPE = 'text-clinical-notes-type',
}
export { ClinicalNotesListAliases };
